import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const lastSavedIdUpdate = createAction("lastSavedIdUpdate");
export default createReducer(
  {
    [lastSavedIdUpdate]: (state, payload) => {
      return payload;
    }
  },
  null
);
